import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/SEO';
import Layout from '../components/Layout';

const Tutoring = ({ data, location }) => {
  const { title, summary } = data.markdownRemark.frontmatter;
  const { html } = data.markdownRemark;

  return (
    <Layout bodyClass="page-services-single">
      <SEO title={title} location={location} description={summary} />
      <div className="container pb-6 pt-6 pt-md-10 pb-md-10">
        <div className="row justify-content-start">
          <div className="col-12 col-md-8">
            <div className="service service-single">
              <h1 className="title">{title}</h1>
              <div
                className="content"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query tutoringQuery {
    markdownRemark(fileAbsolutePath: { regex: "/tutoring.md/" }) {
      html
      excerpt
      fields {
        slug
      }
      frontmatter {
        title
        summary
      }
    }
  }
`;

export default Tutoring;
